import {env} from './env.ts';

export type FirebaseConfig = {
    apiKey: string;
    authDomain: string;
};

export const MISSING_FIREBASE_ENV_MESSAGE =
    'VITE_FIREBASE_API_KEY and VITE_FIREBASE_AUTH_DOMAIN are not set. ' +
    'Copy frontend/.env.example to frontend/.env (use GCP secret IDP_APPLICATION_SETUP_API_KEY for the API key locally).';

/**
 * Firebase client config for the web app.
 *
 * - Vitest: values come from `vite.config.ts` `test.env`.
 * - Dev: must be set in `frontend/.env`.
 * - Production bundles: validated at `vite build` time; runtime check is a safety net.
 */
export function getFirebaseConfig(): FirebaseConfig {
    const apiKey = env.firebaseApiKey?.trim() ?? '';
    const authDomain = env.firebaseAuthDomain?.trim() ?? '';

    if (apiKey && authDomain) {
        return {apiKey, authDomain};
    }
    throw new Error(MISSING_FIREBASE_ENV_MESSAGE);
}
